// material-ui
// import Button from '@mui/material/Button';
// import CardMedia from '@mui/material/CardMedia';
// import Link from '@mui/material/Link';
// import Stack from '@mui/material/Stack';
// import Typography from '@mui/material/Typography';

// // project import
// import MainCard from '../../../../shared/common/MainCard';

// // assets
// import avatar from 'assets/images/users/avatar-group.png';
// import AnimateButton from '../../../../shared/common/@extended/AnimateButton';

// ==============================|| DRAWER CONTENT - NAVIGATION CARD ||============================== //

export default function NavCard() {
  return (
    <>
    </>
  );
}